import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import Header from "../pages/Header";
import PortalNavigation from "./PortalNavigation";

const channels = [
  { name: "ТСВ", background: "#1465b8", color: "#1568bd" },
  { name: "1", background: "linear-gradient(145deg, #50c8e8, #0878bd)", color: "white" },
  { name: "1 РОССИЯ", background: "#172c82", color: "white" },
  { name: "НТВ", background: "#25991f", color: "white" },
  { name: "1", background: "#ff3516", color: "white" },
  { name: "ТВЦ", background: "linear-gradient(145deg, #333, #111)", color: "white" },
  { name: "ТНТ", background: "#438dd0", color: "white" },
  { name: "СТС", background: "#ffc510", color: "white" },
  { name: "РЕН", background: "linear-gradient(145deg, #333, #111)", color: "#ff7b28" },
  { name: "БТВ", background: "linear-gradient(145deg, #333, #111)", color: "#ffd500" },
];

const previewDescription =
  "В недалёком будущем выжившие 10 тысяч человек живут в огромном бункере глубиной в 144 этажа. Люди верят, что мир мёртв, воздух снаружи отравлен и выходить на поверхность смертельно опасно. Всю информацию они получают с помощью огромных экранов, на которые";

const previewWidth = 1920;
const visiblePreviewWidth = previewWidth - 200;

const ScaledPortalPreview: React.FC<{
  bannerUrl: string | null;
  scale: 70 | 80 | 90 | 110 | 120;
  order: number;
}> = ({
  bannerUrl,
  scale,
  order,
}) => {
  const factor = scale / 70;
  const visibleChannels =
    scale === 120
      ? channels.slice(0, 8)
      : scale === 110
        ? channels.slice(0, 9)
        : channels;

  return (
  <Box
    sx={{
      width: visiblePreviewWidth,
      minWidth: visiblePreviewWidth,
      flexShrink: 0,
      overflow: "hidden",
      alignSelf: "center",
      order,
    }}
  >
  <Box
    sx={{
      width: previewWidth,
      minWidth: previewWidth,
      bgcolor: "#000",
      color: "#fff",
      overflow: "hidden",
      fontFamily: "Arial, sans-serif",
    }}
  >
    <Box
      sx={{
        position: "relative",
        isolation: "isolate",
        minHeight: 445,
        backgroundImage: bannerUrl ? `url(${bannerUrl})` : "none",
        backgroundRepeat: "no-repeat",
        backgroundPosition: { xs: "center top", md: "right top" },
        backgroundSize: { xs: "cover", md: "auto 100%" },
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          zIndex: 0,
          background: bannerUrl
            ? {
                xs: "linear-gradient(0deg, #000 5%, transparent 65%)",
                md: "linear-gradient(90deg, #000 0%, #000 34%, rgba(0,0,0,.68) 42%, transparent 62%)",
              }
            : "linear-gradient(120deg, #000 45%, #202020)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          width: { xs: "100%", md: "64%" },
          boxSizing: "border-box",
          px: 2.3,
          pt: 2.2,
        }}
      >
        <Box display="flex" alignItems="center" gap={1.4} mb={1.8}>
          <Box
            sx={{
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderLeft: "10px solid #d51d5b",
            }}
          />
          <Typography sx={{ fontSize: 22 * factor, lineHeight: 1 }}>Portal</Typography>
        </Box>

        <Typography sx={{ fontSize: 28 * factor, fontWeight: 700, lineHeight: 1.15 }}>
          Укрытие
        </Typography>
        <Typography sx={{ mt: 0.7, fontSize: 20 * factor, color: "#c6c6c6" }}>
          2023 | Фантастика | США | 3 сезона |{" "}
          <Box
            component="span"
            sx={{ border: "1px solid white", borderRadius: "3px", px: 0.7, color: "white" }}
          >
            18+
          </Box>
        </Typography>

        <Box display="flex" alignItems="center" gap={2} mt={2.2}>
          <Typography sx={{ fontSize: 21 * factor, fontWeight: 700 }}>◉ 7.8</Typography>
          <Box display="flex" alignItems="center" gap={1.2}>
            <Box sx={{ bgcolor: "white", color: "black", borderRadius: 1, px: 1.3, py: 0.3 }}>
              <Typography sx={{ fontSize: 19 * factor, fontWeight: 900 }}>IMDb</Typography>
            </Box>
            <Typography sx={{ fontSize: 20 * factor, fontWeight: 700 }}>8.1</Typography>
          </Box>
        </Box>

        <Typography
          sx={{
            mt: 2.2,
            maxWidth: 1050,
            fontSize: 20 * factor,
            lineHeight: 1.2,
          }}
        >
          {previewDescription}
        </Typography>
      </Box>

      <Box
        sx={{
            position: "absolute",
            zIndex: 3,
          left: 2.5,
          right: 2.5,
          bottom: 8,
          display: "grid",
          gridTemplateColumns: "repeat(12, 1fr)",
          gap: 0.7,
        }}
      >
        {Array.from({ length: 12 }).map((_, index) => (
          <Box
            key={index}
            sx={{ height: 3, borderRadius: 4, bgcolor: index === 0 ? "white" : "#444" }}
          />
        ))}
      </Box>
    </Box>

    <Box sx={{ px: 2.3, pb: 2 }}>
      <Typography sx={{ fontSize: 20 * factor, fontWeight: 700, mb: 1.2 }}>
        ТВ-каналы
      </Typography>
      <Box sx={{ display: "flex", gap: 2.2, overflowX: "auto", pb: 0.5 }}>
        {visibleChannels.map((channel, index) => (
          <Box
            key={`compact-${channel.name}-${index}`}
            sx={{
              flex: `0 0 ${100 * factor}px`,
              height: 100 * factor,
              borderRadius: 1.2,
              border: index === 0 ? "3px solid white" : "none",
              boxSizing: "border-box",
              background: channel.background,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                color: channel.color,
                bgcolor: index === 0 ? "white" : "transparent",
                px: index === 0 ? 0.7 : 0,
                fontSize: (channel.name.length > 5 ? 18 : 34) * factor,
                fontWeight: 900,
                whiteSpace: "nowrap",
              }}
            >
              {channel.name}
            </Typography>
          </Box>
        ))}
      </Box>
      <Typography sx={{ mt: 1.2, fontSize: 20 * factor, fontWeight: 700 }}>
        Продолжить просмотр
      </Typography>
    </Box>
  </Box>
  </Box>
  );
};

const Preview: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [bannerUrl, setBannerUrl] = useState<string | null>("/8546.2.jpg");

  useEffect(() => {
    return () => {
      if (bannerUrl?.startsWith("blob:")) URL.revokeObjectURL(bannerUrl);
    };
  }, [bannerUrl]);

  const handleClose = () => {
    setDialogOpen(false);
    setSelectedFile(null);
  };

  const handleAddBanner = () => {
    if (!selectedFile) return;

    setBannerUrl(URL.createObjectURL(selectedFile));
    handleClose();
  };

  return (
    <Box minHeight="100vh" display="flex" flexDirection="column">
      <Header />

      <Box display="flex" flexDirection="column" alignItems="center" p={2}>
        <PortalNavigation />

        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => setDialogOpen(true)}
        >
          Добавить баннер
        </Button>
      </Box>

      <Typography
        variant="h5"
        align="center"
        sx={{ width: "100%", py: 2, fontWeight: 700, order: 2 }}
      >
        Масштаб 70%
      </Typography>
      <ScaledPortalPreview bannerUrl={bannerUrl} scale={70} order={2} />

      <Typography
        variant="h5"
        align="center"
        sx={{ width: "100%", py: 2, fontWeight: 700, order: 3 }}
      >
        Масштаб 80%
      </Typography>
      <ScaledPortalPreview bannerUrl={bannerUrl} scale={80} order={3} />

      <Typography
        variant="h5"
        align="center"
        sx={{ width: "100%", py: 2, fontWeight: 700, order: 4 }}
      >
        Масштаб 90%
      </Typography>
      <ScaledPortalPreview bannerUrl={bannerUrl} scale={90} order={4} />

      <Typography
        variant="h5"
        align="center"
        sx={{ width: "100%", py: 2, fontWeight: 700, order: 1 }}
      >
        Масштаб 100%
      </Typography>
      <Box
        sx={{
          width: visiblePreviewWidth,
          minWidth: visiblePreviewWidth,
          flexShrink: 0,
          overflow: "hidden",
          alignSelf: "center",
          order: 1,
        }}
      >
      <Box
        sx={{
          width: previewWidth,
          minWidth: previewWidth,
          bgcolor: "#000",
          color: "#fff",
          overflow: "hidden",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <Box
          sx={{
            position: "relative",
            isolation: "isolate",
            minHeight: { xs: 520, md: 450 },
            backgroundImage: bannerUrl ? `url(${bannerUrl})` : "none",
            backgroundRepeat: "no-repeat",
            backgroundPosition: { xs: "center top", md: "right top" },
            backgroundSize: { xs: "cover", md: "auto 100%" },
            "&::after": {
              content: '""',
              position: "absolute",
              inset: 0,
              zIndex: 0,
              background: bannerUrl
                ? {
                    xs: "linear-gradient(0deg, #000 5%, transparent 65%)",
                    md: "linear-gradient(90deg, #000 0%, #000 34%, rgba(0,0,0,.68) 42%, transparent 62%)",
                  }
                : "linear-gradient(120deg, #000 45%, #202020)",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              width: { xs: "100%", md: "64%" },
              boxSizing: "border-box",
              px: { xs: 2, md: 2.3 },
              pt: 2.2,
            }}
          >
            <Box display="flex" alignItems="center" gap={1.7} mb={2.2}>
              <Box
                sx={{
                  width: 0,
                  height: 0,
                  borderTop: "9px solid transparent",
                  borderBottom: "9px solid transparent",
                  borderLeft: "15px solid #d51d5b",
                }}
              />
              <Typography sx={{ fontSize: 32, lineHeight: 1 }}>Portal</Typography>
            </Box>

            <Typography sx={{ fontSize: 40, fontWeight: 700, lineHeight: 1.15 }}>
              Укрытие
            </Typography>
            <Typography sx={{ mt: 1, fontSize: 29, color: "#c6c6c6" }}>
              2023 | Фантастика | США | 3 сезона |{" "}
              <Box
                component="span"
                sx={{ border: "2px solid white", borderRadius: "4px", px: 1, color: "white" }}
              >
                18+
              </Box>
            </Typography>

            <Box display="flex" alignItems="center" gap={2.5} mt={3.2}>
              <Typography sx={{ fontSize: 30, fontWeight: 700 }}>◉ 7.8</Typography>
              <Box display="flex" alignItems="center" gap={1.5}>
                <Box sx={{ bgcolor: "white", color: "black", borderRadius: 1.5, px: 1.8, py: 0.5 }}>
                  <Typography sx={{ fontSize: 27, fontWeight: 900 }}>IMDb</Typography>
                </Box>
                <Typography sx={{ fontSize: 29, fontWeight: 700 }}>8.1</Typography>
              </Box>
            </Box>

            <Typography
              sx={{
                mt: 3.2,
                maxWidth: 1050,
                fontSize: { xs: 21, md: 28 },
                lineHeight: 1.2,
              }}
            >
              {previewDescription}
            </Typography>
          </Box>

          <Box
            sx={{
              position: "absolute",
              zIndex: 3,
              left: 2.5,
              right: 2.5,
              bottom: 10,
              display: "grid",
              gridTemplateColumns: "repeat(12, 1fr)",
              gap: 1,
            }}
          >
            {Array.from({ length: 12 }).map((_, index) => (
              <Box
                key={index}
                sx={{ height: 5, borderRadius: 4, bgcolor: index === 0 ? "#00aeef" : "#444" }}
              />
            ))}
          </Box>
        </Box>

        <Box sx={{ px: { xs: 2, md: 2.3 }, pb: 3 }}>
          <Typography sx={{ fontSize: 30, fontWeight: 700, mb: 2.5 }}>
            ТВ-каналы
          </Typography>
          <Box sx={{ display: "flex", gap: { xs: 2, md: 4.2 }, overflowX: "auto", pb: 1 }}>
            {channels.map((channel, index) => (
              <Box
                key={`${channel.name}-${index}`}
                sx={{
                  flex: "0 0 141px",
                  height: 141,
                  borderRadius: 1.5,
                  background: channel.background,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    color: channel.color,
                    bgcolor: index === 0 ? "white" : "transparent",
                    px: index === 0 ? 1 : 0,
                    fontSize: channel.name.length > 5 ? 25 : 48,
                    fontWeight: 900,
                    whiteSpace: "nowrap",
                  }}
                >
                  {channel.name}
                </Typography>
              </Box>
            ))}
          </Box>

          <Typography sx={{ mt: 2, fontSize: 30, fontWeight: 700 }}>
            Продолжить просмотр
          </Typography>
        </Box>
      </Box>
      </Box>

      <Typography
        variant="h5"
        align="center"
        sx={{ width: "100%", py: 2, fontWeight: 700, order: 5 }}
      >
        Масштаб 110%
      </Typography>
      <ScaledPortalPreview bannerUrl={bannerUrl} scale={110} order={5} />

      <Typography
        variant="h5"
        align="center"
        sx={{ width: "100%", py: 2, fontWeight: 700, order: 6 }}
      >
        Масштаб 120%
      </Typography>
      <ScaledPortalPreview bannerUrl={bannerUrl} scale={120} order={6} />

      <Dialog open={dialogOpen} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Добавить баннер</DialogTitle>
        <DialogContent>
          <Button component="label" variant="outlined" sx={{ mt: 1 }}>
            Выбрать JPG
            <input
              hidden
              type="file"
              accept="image/jpeg,.jpg,.jpeg"
              onChange={(event) =>
                setSelectedFile(event.target.files?.[0] ?? null)
              }
            />
          </Button>

          {selectedFile && (
            <Typography sx={{ mt: 2 }}>{selectedFile.name}</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            variant="contained"
            disabled={!selectedFile}
            onClick={handleAddBanner}
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Preview;
